import styled from '@emotion/styled';
import * as main from '@shared/styles/abstracts/vars.module.scss';
import { SMagicBox } from '@shared/styles/styledComponentsCommon';
import { IconButton } from '@shared/ui/index';

export const SBackButton = styled(IconButton)`
  display: none;
  @media (width < ${main.brpMobileL}) {
    display: block;
  }
`;
export const SSMagicBox = styled(SMagicBox)<{ $isSearching: boolean }>`
  ${(p) =>
    p.$isSearching &&
    `@media screen and (max-width: ${main.brpMobileL}) {
								width: 300px;
								margin-left: auto;
						}`}
`;
